import apiService from "./apiService";

const PREFIX = "/institutes";

export const instituteService = {
  checkDomainValidity,
  submitContactDetails,
  resendEmailVerificationCode,
  resendPhoneVerificationCode,
  submitVerificationCodes,
  register,
};

function checkDomainValidity(domain) {
  return apiService.get(`${PREFIX}/self/checkdomain/${domain}`);
}

function submitContactDetails(data) {
  return apiService.post(`${PREFIX}/self/firstStep`, data);
}

function resendEmailVerificationCode(regCode) {
  return apiService.get(`${PREFIX}/self/${regCode}/email/resend`);
}

function resendPhoneVerificationCode(regCode) {
  return apiService.get(`${PREFIX}/self/${regCode}/mobile/resend`);
}

function submitVerificationCodes(data) {
  return apiService.post(`${PREFIX}/self/secondStep`, data);
}

function register(data) {
  return apiService.post(`${PREFIX}/self/register`, data);
}
